import React, { useState } from 'react';
import { Loader, Check } from 'lucide-react';
import { Button } from '../../../components/ui/button';

/**
 * A button that requires one extra click ("Confirm?") before firing — used
 * for mutating admin-console actions (clearing a cache, triggering an ETL
 * run, deactivating a tenant, revoking admin access), since each is a real,
 * cross-user-visible change. No modal, no new dependency.
 *
 * Extracted from OverviewTab.jsx so AdminsPanel/GlobalCachePanel/the
 * tenant Danger Zone can reuse the same confirm affordance instead of each
 * re-implementing it.
 */
const ConfirmAction = ({ label, confirmLabel, cancelLabel, onConfirm, pending, disabled, icon: Icon, variant }) => {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant={variant || 'default'}
          disabled={pending}
          onClick={() => {
            setConfirming(false);
            onConfirm();
          }}
        >
          {pending ? <Loader className="w-3.5 h-3.5 animate-spin mr-1.5" /> : <Check className="w-3.5 h-3.5 mr-1.5" />}
          {confirmLabel}
        </Button>
        <Button size="sm" variant="outline" disabled={pending} onClick={() => setConfirming(false)}>
          {cancelLabel}
        </Button>
      </div>
    );
  }

  return (
    <Button size="sm" variant={variant || 'outline'} disabled={disabled} onClick={() => setConfirming(true)}>
      {Icon && <Icon className="w-3.5 h-3.5 mr-1.5" />}
      {label}
    </Button>
  );
};

export default ConfirmAction;
